import DepsService from 'services/dependencies';

const CONTEXT = 'dashboard';

export const fetchAlerts = (retailerId, locale) => {
  const { url } = DepsService.rest.widgets.alerts.list;
  const queryParams = {};
  const urlParams = { retailerId, locale };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const fetchAlertDetails = (retailerId, alertId, locale, setRead) => {
  const { url } = DepsService.rest.widgets.alerts.details;
  const queryParams = {
    setRead,
    locale,
    alertId,
  };
  const urlParams = {
    retailerId,
  };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const dismissAlert = (retailerId, alertId) => {
  const { url } = DepsService.rest.widgets.alerts.hide;
  const queryParams = {
    alertId,
  };
  const urlParams = {
    retailerId,
  };

  return DepsService.restSrv.update(CONTEXT, url, queryParams, urlParams);
};

export const downloadAlertReport = (retailerId, alertId) => {
  const { url } = DepsService.rest.widgets.alerts.details;
  const queryParams = {
    alertId,
  };
  const urlParams = {
    retailerId,
  };
  const headers = { Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' };

  return DepsService.restSrv.downloadBlob(CONTEXT, url, queryParams, urlParams, headers);
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/alerts.api.js